// import { GetUniqueOrigin, GetUniqueDestination } from "./LLContent";
import { dateFormatDisplay, stableSort, getSorting, currencyFormat } from '../../../Functions';

export function BUHeadCompose(page, rowL, bu, dataUrl) {
  var doc = bu;
  var _y = rowL;
  var _space = page.spacingunit;

  var imageX = 210;

  doc.addImage(dataUrl, "JPEG", imageX, page.headerFromTop, 55, 25);
  _y += _space * 3.6;
  doc.text(206, _y, '"Your Alternative Shipping..."');
  _y += _space * 2;

  return _y;
}

export function BUBodyCompose(page, rowL, bu, data) {
  var doc = bu;
  var _y = rowL;
  var _space = page.spacingunit;

  // var origin = GetUniqueOrigin(data.voyageBranches);
  // var destination = GetUniqueDestination(data.voyageBranches);

  _y = page.margin.top;
  doc.setFont("times", "bold");
  doc.text("OCEAN TRANSPORT GROUP OF COMPANIES INC.", 150, _y, null, null, "center");
  doc.setFont("times", "normal");

  _y += _space;
  doc.text("BUILD-UP REPORT", 150, _y, null, null, "center");

  _y += _space;
  doc.text(data.voyageBranches, 150, _y, null, null, "center" );

  _y += _space * 2;

  var _Yreturn = _y;

  _y = page.margin.top;

  doc.text(20, _y, "Date : " + dateFormatDisplay(new Date()));
  var teu = data.wayBIll.length > 0 ? data.wayBIll.length : "0";

  _y += _space * 2;

  doc.text(20, _y, "Total TEUs: " + teu);

  return _Yreturn;
}

export function BUTableCompose(page, rowL, bu, data) {
  var doc = bu;
  var _y = rowL;
  var _space = page.spacingunit;
  var newPage = false;

  // Legend
  doc.setFont("times", "bold");
  doc.text(170, _y + 3.5, "Legend:");
  doc.setFont("times", "normal");

  doc.text(200, _y + 3.5, "With Permit");
  doc.setDrawColor(0);
  doc.setFillColor(255, 109, 0);
  doc.rect(192, _y, 5, 5, "F");
  doc.setFillColor(0, 0, 0);

  doc.text(240, _y + 3.5, "With Load List");
  doc.setDrawColor(0);
  doc.setFillColor(255, 0, 0);
  doc.rect(232, _y, 5, 5, "F");
  doc.setFillColor(0, 0, 0);

  doc.setFont("times", "bold");
  // doc.text(10, _y + 1, "Date of \nGrounding \n(CY-In)");
  doc.text(10, _y + 6, "Date of \nGrounding");
  _y += _space * 2;
  doc.text(33, _y, "Waybill");
  doc.text(61, _y, "Customers");
  doc.text(150, _y, "Others");
  doc.setFont("times", "normal");
  doc.line(10, _y + 1, 270, _y + 1);

  _y += _space;
  // eslint-disable-next-line
  stableSort(data.wayBIll, getSorting('asc', 'wayBillRef')).map(d => {
    if (_y >= 190) {
      doc.addPage(page.layoutL, page.papersize.unit, page.papersize.format);
      _y = 10;
      _y += _space * 2;
      newPage = true;

      if (newPage) {
        // Legend
        doc.setFont("times", "bold");
        doc.text(170, _y + 3.5, "Legend:");
        doc.setFont("times", "normal");

        doc.text(200, _y + 3.5, "With Permit");
        doc.setDrawColor(0);
        doc.setFillColor(255, 109, 0);
        doc.rect(192, _y, 5, 5, "F");
        doc.setFillColor(0, 0, 0);

        doc.text(240, _y + 3.5, "With Load List");
        doc.setDrawColor(0);
        doc.setFillColor(255, 0, 0);
        doc.rect(232, _y, 5, 5, "F");
        doc.setFillColor(0, 0, 0);

        doc.setFont("times", "bold");
        doc.text(10, _y + 1, "Date of \nGrounding \n(CY-In)");
        _y += _space * 2;
        doc.text(33, _y, "Waybill");
        doc.text(61, _y, "Customers");
        doc.text(150, _y, "Others");
        doc.setFont("times", "normal");
        doc.line(10, _y + 1, 270, _y + 1);

        _y += _space;
      }
    } else {
      newPage = false;
    }

    // var DateGrounded = d.dateGrounded ? dateFormatDisplay(new Date(d.dateGrounded)) : "";
    var DateGrounded = d.dateGrounded ? d.dateGrounded : "";
    var GroundedDate = doc.splitTextToSize(DateGrounded, 20);
    doc.text(10, _y, GroundedDate);
    var cy = doc.splitTextToSize(d.cyName ? d.cyName : d.cy ? d.cy : "", 20);
    doc.text(10, _y + (_space * GroundedDate.length), cy);

    doc.setFont("times", "bold");
    if (d.isWithPermit) {
      doc.setTextColor(255, 109, 0);
      doc.text(33, _y, d.wayBillRef ? d.wayBillRef : "");
      doc.setTextColor(0, 0, 0);
    } else {
      doc.text(33, _y, d.wayBillRef ? d.wayBillRef : "");
    }
    // doc.line(33, _y + 1, 61, _y + 1);
    // doc.text(33, _y + _space, "Old Waybill");
    // doc.line(33, _y + _space + 1, 61, _y + _space + 1);
    // doc.text(33, _y + (_space * 2), d.oldWaybillRef ? d.oldWaybillRef : "");

    doc.line(33, (_y + (_space * 2)) + 1, 61, (_y + (_space * 2)) + 1);
    doc.text(33, _y + (_space * 3), "Booking Ref");
    doc.line(33, _y + (_space * 3) + 1, 61, _y + (_space * 3) + 1);
    doc.text(33, _y + (_space * 3) + _space, d.bookingRef ? d.bookingRef : "");
    doc.setFont("times", "normal");
   
    doc.text(61, _y, "Shipper:");
    var splitShipper = doc.splitTextToSize(d.shipper ? d.shipper : "", 65);
    doc.text(85, _y, splitShipper);

    var commodity = d.goods ? d.goods : "";
    doc.text(150, _y, "Commodity: " + commodity);

    _y += _space;
    var S_y = 0;

    if (splitShipper.length > 1) {
      S_y = _y + _space * (splitShipper.length - 1);
    } else {
      S_y = _y;
    }
    doc.text(61, S_y, "Consignee:");
    var splitConsignee = doc.splitTextToSize(d.consignee ? d.consignee : "", 65);
    doc.text(85, S_y, splitConsignee);

    doc.setFont("times", "bold");
    var containerVan = d.vanNumber ? d.vanNumber : "";
    doc.text(150, _y, "Container Van No.: " + containerVan);

    var seal = d.sealNum ? d.sealNum : "";
    doc.text(225, _y, "Seal No: " + seal);
    doc.setFont("times", "normal");

    _y += _space;
    var mOD = d.modeOfDelivery ? d.modeOfDelivery : "";
    doc.text(150, _y, "Service Mode: " + mOD);
    var dsize = d.size ? d.size : "";
    doc.text(195, _y, "Size: " + dsize);
    var Dvalue = d.declaredValue > 0 ? currencyFormat(d.declaredValue) : "0";
    doc.text(225, _y, "Value: " + Dvalue);

    _y += _space;
    var weT = d.cargoWeight > 0 ? d.cargoWeight : "0";
    doc.text(150, _y, "Weight: " + weT);
    var mOP = d.modeOfPayment ? d.modeOfPayment : "";
    doc.text(190, _y, "Payment: " + mOP);

    _y += _space;
    var cT = d.cargoType ? d.cargoType : "";
    doc.text(150, _y, "Cargo Type: " + cT);

    doc.setFont("times", "bold");
    var withPermit = d.isWithPermit ? "Yes" : "No";
    if (d.isWithPermit) {
      doc.setTextColor(255, 109, 0);
      doc.text(190, _y, "With Permit: " + withPermit);
      doc.setTextColor(0, 0, 0);
    } else {
      doc.text(190, _y, "With Permit: " + withPermit);
    }

    var withLoadList = d.waybillStatus !== "Draft" ? "Yes" : "No";
    if (d.waybillStatus !== "Draft") {
      doc.setTextColor(255, 0, 0);
      doc.text(230, _y, "With Load List: " + withLoadList);
      doc.setTextColor(0, 0, 0);
    } else {
      doc.text(230, _y, "With Load List: " + withLoadList);
    }
    doc.setFont("times", "normal");

    _y += _space;
    var remark = "";
    if(d.remarks && d.remarks !== ""){
      if(d.modeOfDelivery === "PTP" || d.modeOfDelivery === "PTD"){
        if(d.stuffing && !d.originBackload){ remark = 'STUFFING, ' + d.remarks; }
        else if(!d.stuffing && d.originBackload) { remark = 'GROUNDING, BACKLOAD, ' + d.remarks; } 
        else { remark = 'GROUNDING, ' + d.remarks; }
      } else {
        if(d.stuffing && !d.originBackload){ remark = 'STUFFING MANO, ' + d.remarks; }
        else if(!d.stuffing && d.originBackload) { remark = 'GROUNDING, BACKLOAD, ' + d.remarks; }
        else if(d.stuffing && d.originBackload) { remark = 'GROUNDING, BACKLOAD, STUFFING MANO, ' + d.remarks; } 
        else { remark = 'GROUNDING, ' + d.remarks; }
      }
    } else {
      if(d.modeOfDelivery === "PTP" || d.modeOfDelivery === "PTD"){
        if(d.stuffing && !d.originBackload){ remark = 'STUFFING'; }
        else if(!d.stuffing && d.originBackload) { remark = 'GROUNDING, BACKLOAD'; } 
        else { remark = 'GROUNDING'; }
      } else {
        if(d.stuffing && !d.originBackload){ remark = 'STUFFING MANO'; }
        else if(!d.stuffing && d.originBackload) { remark = 'GROUNDING, BACKLOAD'; }
        else if(d.stuffing && d.originBackload) { remark = 'GROUNDING, BACKLOAD, STUFFING MANO'; } 
        else { remark = 'GROUNDING'; }
      }
    }
    doc.text(150, _y, "Remarks: " + remark);

    _y += _space;
    var shipperPreferredName = d.shipperPreferedName ? d.shipperPreferedName : "";
    doc.text(150, _y, "Shipper Preferred Name: " + shipperPreferredName);

    _y += _space;
    var consigneePreferredName = d.consigneePreferedName ? d.consigneePreferedName : "";
    doc.text(150, _y, "Consignee Preferred Name: " + consigneePreferredName);

    doc.line(10, _y + 1, 270, _y + 1);
    _y += _space;
  });
}
